// extracted by mini-css-extract-plugin
module.exports = {"loaderText":"styles_loaderText__2p-Vs","loaderDots":"styles_loaderDots__3e-lV","preloader":"styles_preloader__1CrRS"};